// src/Services.jsx
import RevealOnScroll from "./RevealOnScroll";

const services = [
  {
    title: "Hackathons educacionais",
    description:
      "Planejamento, facilitação e mentoria para hackathons educacionais, apoiando escolas e redes na criação de projetos integradores alinhados ao currículo.",
    icon: "🚀",
  },
  {
    title: "ABP – Aprendizagem Baseada em Projetos",
    description:
      "Apoio pedagógico para implementação de ABP de forma estruturada, conectando desafios reais, investigação e protagonismo estudantil.",
    icon: "📚",
  },
  {
    title: "Cultura maker e experiências mão na massa",
    description:
      "Desenvolvimento de propostas criativas para aproximar teoria e prática usando materiais simples, tecnologias digitais e pensamento computacional.",
    icon: "🛠️",
  },
  {
    title: "Formação continuada de professores",
    description:
      "Formações, workshops e trilhas sobre metodologias ativas, inovação, tecnologias educacionais e transformação digital na educação.",
    icon: "🎓",
  },
  {
    title: "Sequências didáticas e materiais pedagógicos",
    description:
      "Criação de sequências didáticas, roteiros de atividades e materiais de apoio, incluindo práticas em Ciência de Dados e Cultura Digital.",
    icon: "📎",
  },
  {
    title: "Consultoria para escolas e redes de ensino",
    description:
      "Acompanhamento pedagógico e estratégico para implementar inovação, uso de tecnologias e novas metodologias de forma sustentável.",
    icon: "💡",
  },
];

function Services() {
  return (
    <section id="servicos" className="section section--alt">
      <div className="section-inner">
        <h2>O que faço</h2>
        <p>
          Atuo com educação, metodologias ativas e tecnologias digitais, apoiando redes,
          escolas e professores na criação de experiências de aprendizagem mais criativas,
          práticas e alinhadas às necessidades reais dos estudantes.
        </p>

        <div className="services-grid">
          {services.map((service, index) => (
            <RevealOnScroll key={index} delay={index * 120}>
              <div className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </RevealOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
